export function handlePageChange(
  page: number,
  pageSize: number,
  fetchMore: any,
  query: any,
): { limit: number; offset: number } {
  const offset = (page - 1) * pageSize;
  const variables = {
    limit: pageSize,
    offset: offset,
  };
  fetchMore({
    query: query,
    updateQuery: (_, { fetchMoreResult }) => {
      return fetchMoreResult;
    },
    variables: variables,
  });
  return variables;
}

export const DEFAULT_FEED_QUERY_LIMIT = 20;
